import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { useRole } from '../../Shared/hooks/CustomHooks';
import { countOfRecourd } from '../../Shared/utils/helper';
/** @format */
import Master from '../Layouts/Master';

const Event = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const { can } = useRole();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [formRemoveId, setFormRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getEvents();
  }, [search]);
  const getEvents = async () => {
    setLoading(true);
    await useApi.get(
      `/event${search}`,
      {},
      (res) => {
        eventContext.events = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeForm = async (eventId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/event/${eventId}`,
      {},
      (res) => {
        success('رویداد مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getEvents();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست رویداد ها
          </h1>
        </div>
        <Link
          to='/panel/event/create'
          className='d-flex flex-row btn btn-outline-info '
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>ایجاد رویداد</span>
        </Link>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.events?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>شروع</th>
                <th>پایان</th>
                <th>زمان</th>
                <th>فرم ثبت نام</th>
                <th>ثبت نام شده ها</th>
                {can('Super Admin') || can('Dyaco Admib') ? (
                  <th>دسترسی ویرایش</th>
                ) : null}
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.events?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {countOfRecourd(
                      index,
                      eventContext.events?.meta?.pagination?.per_page,
                      eventContext.events?.meta?.pagination?.current_page,
                    )}
                  </th>
                  <td>{item.title}</td>
                  <td>
                    {moment(
                      item.start_register_date ?? '1999-01-01 00:00:00',
                      'YYYY-MM-DD HH:mm:ss',
                    )
                      .locale('fa')
                      .format('YYYY-MM-DD')}
                  </td>
                  <td>
                    {moment(
                      item.end_register_date ?? '1999-01-01 00:00:00',
                      'YYYY-MM-DD HH:mm:ss',
                    )
                      .locale('fa')
                      .format('YYYY-MM-DD')}
                  </td>
                  <td>{item.time}</td>
                  <td>{item.form?.title}</td>
                  <td>
                    <Link
                      to={
                        item.type === 1
                          ? `/panel/event/register/${item.id}`
                          : `/panel/event/${item.id}/team`
                      }
                      target='_blank'
                      className='btn btn-info btn-sm d-flex flex-row justify-content-center p-2'
                    >
                      <i className='fad fa-eye text-dark-mode f-15'></i>
                    </Link>
                  </td>
                  {can('Super Admin') || can('Dyaco Admin') ? (
                    <td>
                      <Link
                        to={`/panel/event/${item?.id}/access-province`}
                        target='_blank'
                        className='btn btn-info btn-sm d-flex flex-row justify-content-center p-2'
                      >
                        <i className='fad fa-eye text-dark-mode f-15'></i>
                      </Link>
                    </td>
                  ) : null}
                  <td>
                    <div className='d-flex flex-row'>
                      <Link
                        to={`/panel/event/edit/${item.id}`}
                        className='mx-2'
                      >
                        ویرایش
                      </Link>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setFormRemoveId(item.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد فرم بر روی منوی ایجاد فرم کلیک کنید
            </span>
          </div>
        )}
      </div>

      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.events?.meta?.pagination?.total_pages}
          basePath={`/panel/event`}
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف فرم مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeForm(formRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Event;
